import { Aseguradora } from './aseguradora';
import { inherits } from 'util';
import { Archivo } from './archivo';

export class Compras {

}

export class PendienteCotizar {
    idOrdenServicio: number;
    ordenServicio: string;
    fechaRecepcion: Date;
    fechaValuacion: Date;
    fechaCotizacion: Date;
    aseguradora: Aseguradora;
}

export class CotizacionCompras {
    idComprasCotizacion: number;
    idValuacionDetalle: number;
    idProveedor: number;
    precioProveedor: number;
    seleccionado: boolean;
    idEmpleado: number;
    proveedor: string;
    fechaCotizacion: Date;
}

export class CuentasxPagar {
    idOrdenServicio: number;
    ordenServicio: string;
    total: number;
    abonado: number;
    pagado: boolean;
    fechaVencimiento: Date;
    fechaCaptura: Date;
    resta: number;
    diasVencido: number;
    facturas: FacturaProveedor[] = [];
}

export class ResumenCuentaProveedor{
    abonado: number;
    idProveedor: number;
    pagado: boolean;
    proveedor: string;
    resta: number;
    total: number;
    totalOS: number;
    vencido: number;
    xVencer: number;
}

export class CuentaProveedor {
    idProveedor: number;
    proveedor: string;
    totalOS: number;
    total: number;
    abonado: number;
    resta: number;
    pagado: number;
}

export class PagoProveedor {
    idPagoProveedor: number;
    total: number;
    abonado: number;
    pagado: boolean;
    proveedor: string;
    credito: boolean;
    idCotizacionDetalle: number;
}

export class FacturaProveedor {

    idFacturaProveedor: number;
    idOrdenServicio: number;
    factura: string;
    folioFiscal: string;
    montoFactura: number;
    subTotal: number;
    iva: number;
    comentario: string;
    diasCredito: number;
    fechaFactura: Date;
    fechaVencimiento: Date;
    fechaPago: Date;
    idProveedor: number;
    proveedor: string;
    razonSocial: string;
    metodoPago: string;
    clabe: string;
    banco: string;
    cuenta: string;
    rfc: string;
    concepto: string;
    status: string;
    pagado: boolean;
    ordenServicio: string;
    detallePago: DetallePagoProveedor[] = [];
    detalleFactura: DetalleFacturaProveedor[] = [];
    diasVencido: number;
    idEmpleado: number;
    idArchivo: number;
    idComprobantePago: number;
    archivo: Archivo;
    comprobantePago: Archivo;
    adicional: boolean;
    selected: boolean = false;
    idSucursal: number;
    sucursal: string;
    idMetodoPago: number;
    idFormaPago: number;
    contenidoXML: string;
    metodoPagoSAT: string;
    formaPagoSAT: string;
}

export class DetallePagoProveedor extends PagoProveedor {
    cantidad: number;
    descripcion: string;
    idOrdenServicio: number;
    ordenServicio: number;
    seleccionado: boolean;
}

export class PrecioProveedor {
    idProveedor: number;
    precio: number;
}

export class PagarFactura {
    idFacturaProveedor: number;
    pagado: boolean;
    idEmpleado: number;
    fechaPago: Date;
}

export class ProcesoCompra {
    idOrdenServicio: number;
    cantidad: number;
    descripcion: string;
    costoAutorizado: number;
    costoCotizado: number;
    fechaPedido: Date;
    fechaSurtido: Date;
    autorizado: boolean;
    comentarioPlan: string;
    comentarios: string;
    cnb: string;
    edicionComentarios: boolean;
    edicionCnb: boolean;
}


export class DetalleFacturaProveedor {
    idOrdenServicio: number;
    cantidad: number;
    idValuacionDetalle: number;
    descripcion: string;
    costoUnitario: number;
    costoAutorizado: number;
    autorizado: boolean;
    idFacturaProveedor: number;
    seleccionado: boolean;
    factura: string;
    error: boolean;
    comentario: string;
}

export class PagarFacturaProveedor {
    idFacturaProveedor: number;
    pagado: boolean;
    idEmpleado: number;
    fechaPago: Date;
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/compras.ts